import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import React from 'react';
import { Button } from '@/components/ui/button';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function ErroStep() {
  const history = useHistory();
  return (
    <div className="flex flex-col sm:flex-row sm:gap-4">
      <div className="sm:w-3/3">
        <Card>
          <CardHeader>
            <Heading variant="2" className={'text-red-600'}>
              Apmokėjimas nepavyko.
            </Heading>
          </CardHeader>
          <CardContent>
            Atsiprašome, tačiau jūsų apmokėjimas nepavyko dėl nenumatytos
            klaidos.
          </CardContent>
          <CardFooter>
            <Button
              variant={'light'}
              className="sm:block sm:w-full"
              onClick={() => {
                history.push('/');
              }}
            >
              Grįžti į pradinį puslapį.
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
